import React from "react";
import {
  CustomCreatableSelect,
  SelectContainer,
  CustomSelect,
  IconDiv,
  Styles,
  Label,
  Inner,
} from "./select.styles";

const MainSelect = ({
  id,
  name,
  label,
  error,
  options,
  onChange,
  leftIcon,
  rightIcon,
  placeholder,
  iSearchable,
  flat = false,
  isMulti = false,
  createable = false,
  ...otherProps
}) => (
  <>
    {label && <Label htmlFor={id}>{label}</Label>}
    <SelectContainer flat={flat} isMulti={isMulti}>
      <Inner>
        <IconDiv htmlFor={id} hidden>
          {leftIcon}
        </IconDiv>
        {/** selectinput that accept user typed-in value */}
        {createable ? (
          <CustomCreatableSelect
            id={id}
            placeholder={placeholder}
            options={options}
            isMulti={isMulti}
            iSearchable={iSearchable}
            styles={(Styles, {})}
            onChange={onChange}
            onCreateOption={() => {}}
            {...otherProps}
          />
        ) : (
          <CustomSelect
            id={id}
            placeholder={placeholder}
            options={options}
            isMulti={isMulti}
            iSearchable={iSearchable}
            styles={Styles}
            onChange={onChange}
            {...otherProps}
          />
        )}

        <IconDiv right htmlFor={id} hidden>
          {rightIcon}
        </IconDiv>
      </Inner>
    </SelectContainer>
    {error && <div className="text-danger mt-1">{error}</div>}
  </>
);

export default MainSelect;
